import React from 'react'

import { MFASuppressionNoOptions, SendCodeContent } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'
import { useAppState } from '../../AppStateProvider'
import { useHostServices } from '../../HostServices'

export const SendCodeWrapper: React.FC = () => {
  const { activeScreen, isInPortal, logger } = useTransmit()
  const { isWebWrapped } = useAppState()
  const hostServices = useHostServices()

  switch (activeScreen.type) {
    case 'SendCode':
      return (
        <SendCodeContent
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...activeScreen.payload}
          hostServices={hostServices}
          isInPortal={isInPortal}
          isWebWrapped={isWebWrapped}
          logger={logger}
          variation={hostServices.featureFlags.variation}
        />
      )
    case 'MFASuppressionNoOptions':
      return <MFASuppressionNoOptions />
    default:
      return null
  }
}
